module.exports = __webpack_public_path__ + "static/media/Cute-Cat.d09dbe3a.jpg";